import React, { useEffect } from 'react'
import { Link, NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom'

const img = (name: string) => `${process.env.PUBLIC_URL}/images/${name}`

export default function Layout() {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  // Scroll to top on route change (so Terms/Privacy open at the top).
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  // Scroll to the features section — navigating home first if we're elsewhere.
  // (We scroll via JS rather than an #anchor so it doesn't fight the hash router.)
  const goFeatures = (e: React.MouseEvent) => {
    e.preventDefault()
    const scroll = () => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })
    if (pathname !== '/') {
      navigate('/')
      window.setTimeout(scroll, 80)
    } else {
      scroll()
    }
  }

  return (
    <>
      <header className="nav">
        <div className="container nav-inner">
          <Link to="/" className="brand">
            <img src={img('heard-icon.png')} alt="Heard" />
            Heard
          </Link>
          <nav className="nav-links">
            <NavLink to="/">Home</NavLink>
            <a href="/" onClick={goFeatures}>Features</a>
            <NavLink to="/privacy">Privacy</NavLink>
            <NavLink to="/contact">Contact</NavLink>
          </nav>
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className="footer">
        <div className="container footer-inner">
          <span>© {new Date().getFullYear()} Alana .sh · Heard</span>
          <div className="footer-links">
            <Link to="/terms">Terms of Use</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>
      </footer>
    </>
  )
}
